import { StringKeyDictionary } from "../commonInterfaces";
import { AdditionalData, Entity } from "../core/components/commonApp";
import {
    BaseColumn,
    EditableGrid,
    EditableGridProps,
    field,
    InGridButtonClickParams,
    InGridToolBarButton,
    Schema,
    ValidationResult,
    ValidationResultType
} from "../core/components/editableGrid/editableGrid";
import { EditableGridHelper } from "../core/components/editableGrid/editableGridHelper";
import { ValidationBuilder } from "../core/components/editableGrid/validationBuilder";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { CashExpensesHelper } from "../core/util/cashExpensesHelper";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Baraus } from "../generalSettings/serviceReport/cashExpense";
import { EntityServiceReport } from "./serviceReport";
import React from "react";

export class ServiceReportCashExpensesInGrid extends React.Component<ServiceReportCashExpensesGridProps, {
}>{
    translations: StringKeyDictionary<string> = null;
    editableGridRef: EditableGrid;

    constructor(props: any) {
        super(props)
        this.state = {
            Schema: null,
            Columns: null
        };
        this.translations = this.props.translations;
    }

    private getMachineAdditionalData = async (maschNr: string): Promise<AdditionalData> => {
        let result = await HTTPService.get<AdditionalData>("MachineLookUp/GetMachineAdditionalData", { id: maschNr });
        return result;
    }

    private getCashExpense = async (nr: number, idBaraus: number): Promise<Baraus> => {
        let result = await HTTPService.get<JsonResultClass<Baraus>>("CashExpenses/GetCashExpense", { nr: nr, idBaraus: idBaraus });
        return result.Data;
    }

    private calculateAndSetValues = (dataItem: any) => {
        let sum = CashExpensesHelper.getSum(dataItem.Tkk, dataItem.Wert);
        let sumInCurrency = CashExpensesHelper.getSumInCurrency(sum, dataItem.Faktor);
        let expenses = CashExpensesHelper.getExpenses(dataItem.Tkk, dataItem.Wert, dataItem.Kostenfaktor, dataItem.Spesenbetrag);
        let invoice = CashExpensesHelper.getInvoice(dataItem.Tkk, dataItem.Wert, dataItem.Fakturafaktor, dataItem.Fakturabetrag);
        dataItem.set("Summe", sum);
        dataItem.set("CurrIntSumme", sumInCurrency);
        dataItem.set("Spesen", expenses);
        dataItem.set("Faktura", invoice);
    }

    private setCurrency = (currency: string, changedDataItem: any) => {
        let factor = 1;
        let symbol;
        if (Helper.hasValue(this.props.entity.ConvertToTargetCurrencies)) {
            let cuFaktor = this.props.entity.ConvertToTargetCurrencies.find(x => x.Currency == currency);
            factor = cuFaktor?.Factor;
            symbol = cuFaktor?.Characters;
        }
        changedDataItem.set("Currency", currency);
        changedDataItem.set("Faktor", factor);
        changedDataItem.set("CurrencySymbol", symbol);
    }

    private setBarausValues(changedDataItem: any, cashExpenseVm: Baraus) {
        changedDataItem.set("Schluesseltext", cashExpenseVm?.OriginalDescription);
        if (!Helper.hasValue(changedDataItem.Tkk))
            changedDataItem.set("Tkk", cashExpenseVm?.Quantity ?? 1);
        if (!Helper.hasValue(changedDataItem.Wert))
            changedDataItem.set("Wert", cashExpenseVm?.Amount ?? 1);
        if (!Helper.hasValue(changedDataItem.Kostenfaktor))
            changedDataItem.set("Kostenfaktor", cashExpenseVm?.CostFactor);
        if (!Helper.hasValue(changedDataItem.Spesenbetrag))
            changedDataItem.set("Spesenbetrag", cashExpenseVm?.ExpensesAmount);
        if (!Helper.hasValue(changedDataItem.Fakturafaktor))
            changedDataItem.set("Fakturafaktor", cashExpenseVm?.InvoiceFactor);
        if (!Helper.hasValue(changedDataItem.Fakturabetrag))
            changedDataItem.set("Fakturabetrag", cashExpenseVm?.InvoiceAmount);
        changedDataItem.set("NullBetrag", cashExpenseVm?.ZeroAmount);
        changedDataItem.set("LockWert", cashExpenseVm?.LockAmount);
        changedDataItem.set("LockAnzahl", cashExpenseVm?.LockQuantity);
    }

    private resolveAdditionalData = async (newValue: any, fieldName: string, fullObject: any, options: any) => {
        switch (fieldName) {
            case "Schluessel":
                let cashExpenseVm = await this.getCashExpense(newValue, this.props.entity.IdBaraus);
                if (!Helper.hasValue(options.model?.Currency)) {
                    let currency = cashExpenseVm?.CurrencyId ?? this.props.entity.TargetCurrency.Currency;
                    this.setCurrency(currency, options.model);
                }
                this.setBarausValues(options.model, cashExpenseVm);
                this.calculateAndSetValues(options.model);
                let schlusselAdditionalData: AdditionalData = { Description: cashExpenseVm?.Description };
                return schlusselAdditionalData;
            case "Maschnr":
                let maschineView = await this.getMachineAdditionalData(newValue);
                return maschineView;
            case "Kls":
                let klsAdditionalData: AdditionalData = { Description: fullObject?.verursacher };
                return klsAdditionalData;
        }
    }

    private flag: boolean = false;
    onGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            this.handleItemChanged(fieldName, dataItems);
            this.flag = false;
        }
        else if (action == "add") {
        }
        else if (action == "remove") {

        }
        this.props.onChange();
    }

    private async handleItemChanged(fieldName: string, dataItems) {
        let changedDataItem = dataItems[0];
        this.flag = true;
        let dataItem: EntityServiceReportCashExpenses = changedDataItem;
        switch (fieldName) {
            case "Datum":
                changedDataItem.set("WeekDay", kendo.toString(kendo.parseDate(changedDataItem.Datum), "ddd"));
                break;
            case "Tkk":
            case "Wert":
                this.calculateAndSetValues(dataItem);
                break;
            case "Faktor":
                let tmpSumFactor = CashExpensesHelper.getSumInCurrency(dataItem.Summe, dataItem.Faktor);
                changedDataItem.set("CurrIntSumme", tmpSumFactor);
                break;
            case "Currency":
                this.setCurrency(dataItem.Currency, changedDataItem);
                let tmpSumCurrency = CashExpensesHelper.getSumInCurrency(dataItem.Summe, dataItem.Faktor);
                changedDataItem.set("CurrIntSumme", tmpSumCurrency);
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Wert");
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Spesen");
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Faktura");
                this.editableGridRef.refreshColumnTemplate(changedDataItem, "Summe");
                break;
        }
        if (this.props.entity.RueckreiseModusActivated)
            changedDataItem.set("ErfasstNachSignatur", true);
        changedDataItem.set("Changed", true);
    }

    private createNewEntity(): EntityServiceReportCashExpenses {
        let newEntry: EntityServiceReportCashExpenses = {
            IsNew: true,
            Changed: true,
            IndividualFields: {},
            GlobalCurrInt: this.props.entity.GlobalCurrInt,
            RecordRight: this.props.entity.RecordRight,
            IsWatchable: this.props.entity.IsWatchable,
            IsWatched: this.props.entity.IsWatched,
            ErfasstNachSignatur: this.props.entity.RecordRight.IsRueckModusAdded,
            HasBarausRef: true,
            IsBarausDeleted: false
        }
        return newEntry;
    }

    private calcNewValues(dataSource: kendo.data.DataSource, newEntry: EntityServiceReportCashExpenses) {
        let entries = (dataSource.data() as any) as EntityServiceReportCashExpenses[];
        let destroyedData = dataSource["destroyed"]();

        let newDate = kendo.parseDate(this.props.entity.Dvon);
        let newPos = 1;

        if (entries.length >= 1) {
            newDate = entries.filter(x => Helper.hasValue(x.Datum)).reduce((prev, current) => (prev.Datum > current.Datum) ? prev : current).Datum;
            newPos = entries.filter(x => Helper.hasValue(x.Pindex)).reduce((prev, current) => (prev.Pindex > current.Pindex) ? prev : current).Pindex + 1;
        }
        if (destroyedData.length >= 1) {
            let destroyedMaxPos = destroyedData.filter(x => Helper.hasValue(x.Pindex)).reduce((prev, current) => (prev.Pindex > current.Pindex) ? prev : current).Pindex + 1;
            if (destroyedMaxPos > newPos)
                newPos = destroyedMaxPos;
        }

        newEntry.Datum = newDate;
        newEntry.WeekDay = kendo.toString(newDate, "ddd");
        newEntry.Pindex = newPos;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    onRequestItemValidation = (columns: BaseColumn[], dataItem: EntityServiceReportCashExpenses): ValidationResult => {
        var allowZeroAmount = Helper.hasValue(dataItem.NullBetrag) && dataItem.NullBetrag == 1;

        return new ValidationBuilder()
            .checkReqiredFields(columns, dataItem)
            .addWarning(!dataItem.HasBarausRef, Helper.getTranslation("Field.Barauslage.LinkedCashExpenseMissing"))
            .addWarning(dataItem.IsBarausDeleted && dataItem.IsBarausDeleted, Helper.getTranslation("Field.Barauslage.LinkedCashExpenseDeleted"))
            .addError(!Helper.hasValue(dataItem.Tkk) || (!allowZeroAmount && dataItem.Tkk <= 0),
                Helper.getTranslation("Validierung.FeldMussEinenWertHaben").replace("{Field}", Helper.getTranslation("Field.Barauslage.tkk")))
            .addError(!Helper.hasValue(dataItem.Wert) || (!allowZeroAmount && dataItem.Wert <= 0),
                Helper.getTranslation("Validierung.FeldMussEinenWertHaben").replace("{Field}", Helper.getTranslation("Field.Barauslage.wert")))
            .addError(!Helper.hasValue(dataItem.Faktor) || (!allowZeroAmount && dataItem.Faktor <= 0),
                Helper.getTranslation("Validierung.FeldMussEinenWertHaben").replace("{Field}", Helper.getTranslation("Field.Barauslage.faktor")))
            .build();
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                const entity: EntityServiceReportCashExpenses = this.createNewEntity();
                this.calcNewValues(p.dataSource, entity);
                p.actions.add(entity);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
        }
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite && !this.props.entity.RecordRight.IsRueckModusReadOnly;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit", enabled: (p) => this.props.entity.RecordRight.CanWrite && p.hasSingleSelection });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

        let schema = new Schema();
        schema.Id = "Pindex";
        schema.fields["Pindex"] = new field("number");
        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid
                editable={editable}
                data={this.props.data}
                gridOptions={this.props.gridOptions}
                schema={schema}
                resolveAdditionalData={this.resolveAdditionalData}
                onDataChanged={this.onGridDataChanged}
                ref={(ref) => this.editableGridRef = ref}
                onRequestItemValidation={this.onRequestItemValidation}
                rowReadOnly={(dataItem) => !dataItem.ErfasstNachSignatur && this.props.entity.RecordRight.IsRueckModusAdded}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                {...this.props}
                id="srCashExpenses"
            />
        </div>
    }
}

export interface ServiceReportCashExpensesGridProps extends EditableGridProps {
    entity: EntityServiceReport;
    data: EntityServiceReportCashExpenses[];
    gridOptions: any;
    dataSources: any;
    translations: StringKeyDictionary<string>;
    onChange?: () => void;
}

export interface EntityServiceReportCashExpenses extends Entity {
    Pindex?: number;
    ErfasstNachSignatur?: boolean;
    Schluessel?: number;
    Schluessel_additional_data?: AdditionalData;
    CurrIntSumme?: number;
    Tkk?: number;
    Summe?: number;
    Wert?: number;
    Faktor?: number;
    Faktura?: number;
    Spesen?: number;
    Datum?: Date;
    WeekDay?: string;
    Currency?: string;
    Changed?: boolean;
    Kls?: string;
    Kls_additional_data?: AdditionalData;
    Bezeichnung?: string;
    Bemerkung?: string;
    Rechnungstext?: string;
    Verursacher?: string;
    LockWert?: boolean;
    LockAnzahl?: boolean;
    GlobalCurrInt: string;
    Maschnr?: string;
    Maschnr_additional_data?: AdditionalData;
    HasBarausRef?: boolean;
    IsBarausDeleted?: boolean;
    Kostenfaktor?: number;
    Spesenbetrag?: number;
    Fakturafaktor?: number;
    Fakturabetrag?: number;
    NullBetrag?: number;
    CurrencySymbol?: string;
    Isguid?: string;
    DocumentsCount?: number;
}

